/**
 * <yg-delivery> — kargo son saatine kalan süreyi canlı gösterir.
 *
 * Liquid, mağaza saat diliminde hesapladığı son saati MUTLAK bir epoch
 * damgası olarak (data-deadline) verir. Kalan süre her tikte Date.now()
 * ile yeniden hesaplanır — sayaç düşürülmez. Sebebi: arka plana atılan
 * sekmede setInterval kısılır, sayfa kenar sunucuda önbelleklenebilir ve
 * sayfa uzun süre açık kalabilir. Bunların hepsinde düşen sayaç kayar ve
 * 17:00'dan sonra "Bugün kargoda" yazısı ekranda kalırdı.
 *
 * Süre dolduğunda başlık, data-next-text'ten bütün olarak değiştirilir —
 * metin içinde arama/replace yapılmaz, böylece mağaza sahibi metni tema
 * editöründen değiştirdiğinde de doğru çalışır.
 */
if (!customElements.get('yg-delivery')) {
  customElements.define(
    'yg-delivery',
    class YgDelivery extends HTMLElement {
      #timer = null;
      #deadline = 0;
      #onWake = () => this.#render();

      connectedCallback() {
        // Yeniden baglanmada (tema editoru siralamasi, section morph) eski
        // zamanlayici kalmasin.
        this.#stop();

        this.countdown = this.querySelector('[data-yg-delivery-countdown]');
        this.headline = this.querySelector('[data-yg-delivery-headline]');
        this.#deadline = Number(this.dataset.deadline) * 1000;

        if (!this.#deadline) return;

        this.#render();
        this.#timer = setInterval(this.#onWake, 30_000);
        document.addEventListener('visibilitychange', this.#onWake);
        window.addEventListener('pageshow', this.#onWake);
      }

      disconnectedCallback() {
        this.#stop();
        document.removeEventListener('visibilitychange', this.#onWake);
        window.removeEventListener('pageshow', this.#onWake);
      }

      #stop() {
        if (this.#timer) clearInterval(this.#timer);
        this.#timer = null;
      }

      #render() {
        const remaining = this.#deadline - Date.now();

        if (remaining <= 0) {
          this.#stop();
          if (this.countdown) this.countdown.textContent = '';
          if (this.headline && this.dataset.nextText) {
            this.headline.textContent = this.dataset.nextText;
          }
          return;
        }

        if (!this.countdown) return;
        const totalMinutes = Math.floor(remaining / 60_000);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        this.countdown.textContent =
          hours > 0 ? `Son ${hours} saat ${minutes} dakika` : `Son ${minutes} dakika`;
      }
    }
  );
}
